import React, { useEffect, useState } from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { OppHero, FilterBar } from "../components/opportunities/OppHero";
import OppExplorer from "../components/opportunities/OppExplorer";
import OurSolutionsSection from "../components/opportunities/OurSolutionsSection";
import AiInActionSection from "../components/opportunities/AiInActionSection";
import SuccessStoryCtaSection from "../components/opportunities/SuccessStoryCtaSection";
import AiStrategyExpertSection from "../components/opportunities/AiStrategyExpertSection";

const AiOpportunities = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const urlTab = searchParams.get("tab");
  const industryParam = searchParams.get("industry");
  const functionParam = searchParams.get("fn") || searchParams.get("function");

  const [tab, setTab] = useState(urlTab || "Industries");

  // Keep tab in sync if urlTab changes
  useEffect(() => {
    if (urlTab && urlTab !== tab) {
      setTab(urlTab);
    }
  }, [urlTab]);

  // Tab change handler from FilterBar buttons
  const handleTabChange = (newTab) => {
    setTab(newTab);
    const newParams = new URLSearchParams(searchParams);
    newParams.set("tab", newTab);
    if (newTab !== "Industries") {
      newParams.delete("industry");
    }
    if (newTab !== "Business Function") {
      newParams.delete("fn");
      newParams.delete("function");
    }
    setSearchParams(newParams, { replace: true });
  };

  // Scroll to Explore Opportunities By section when industry, function, tab, or hash is provided
  useEffect(() => {
    const hasTarget = industryParam || functionParam || searchParams.get("tab") || location.hash;
    if (hasTarget) {
      const timer = setTimeout(() => {
        const el =
          document.getElementById("explore-opportunities-by") ||
          document.getElementById("explorer");
        if (el) {
          const navHeight = 85;
          const rect = el.getBoundingClientRect();
          const targetY = rect.top + window.scrollY - navHeight;
          window.scrollTo({ top: targetY, behavior: "smooth" });
        }
      }, 150);
      return () => clearTimeout(timer);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.search, location.hash, industryParam, functionParam]);

  return (
    <div className="min-h-screen w-full bg-white">
      <Navbar />
      <main>
        <OppHero />
        <FilterBar active={tab} setActive={handleTabChange} />
        
        {/* Pass the active tab, selected industry, and selected function down to the Explorer */}
        <OppExplorer
          activeTab={tab}
          selectedIndustry={industryParam}
          selectedFunction={functionParam}
        />
        
        {/* New "How we turn AI into business value" Section with custom background */}
        <OurSolutionsSection />

        {/* AI in action: Real solutions, real results (Case Studies) */}
        <AiInActionSection />
        
        {/* Success Story CTA Banner Section */}
        <SuccessStoryCtaSection />

        {/* Let's Talk: Enough about what AI can do Section */}
        <AiStrategyExpertSection />
      </main>
      <Footer />
    </div>
  );
};

export default AiOpportunities;